import type { IAccessControl } from './types';

import HTTP from '@/utils/http';

export const accessControlService = {
  getAccessControls: () => HTTP.get<IAccessControl>(`access-status`).then(response => response.data),
};
